import { createFileRoute } from '@tanstack/react-router'
import {
  knowledgeBaseGraphQueryOptions,
  publishedKnowledgeBasesQueryOptions,
} from '@/lib/queries'
import {
  KnowledgeGraphView,
  KnowledgeGraphRoutePending,
} from '@/components/graph/KnowledgeGraphView'

/**
 * Knowledge Graph — published knowledge-base list, then
 * GET /knowledge_bases/{id}/graph for the selected base.
 */
export const Route = createFileRoute('/_app/business-knowledge')({
  loader: async ({ context: { queryClient } }) => {
    const bases = await queryClient.ensureQueryData(
      publishedKnowledgeBasesQueryOptions,
    )
    const first = bases[0]
    if (!first) return bases
    await queryClient.ensureQueryData(knowledgeBaseGraphQueryOptions(first.id))
    return bases
  },
  pendingComponent: KnowledgeGraphRoutePending,
  // Show KG skeleton immediately — default pendingMs keeps the home pulse visible.
  pendingMs: 0,
  pendingMinMs: 0,
  component: KnowledgeGraphView,
})
